export const SET_HRMS6AE_INDEX_DISP = 'SET_HRMS6AE_INDEX_DISP'
export const GET_HRMS6AE_INDEX_DISP = 'GET_HRMS6AE_INDEX_DISP'
export const SET_HRMS6AE_DETAIL_DISP = 'SET_HRMS6AE_DETAIL_DISP'
export const GET_HRMS6AE_DETAIL_DISP = 'GET_HRMS6AE_DETAIL_DISP'
export const SET_HRMS6AE_MAX_ROWSPAN = 'SET_HRMS6AE_MAX_ROWSPAN'
export const GET_HRMS6AE_MAX_ROWSPAN = 'GET_HRMS6AE_MAX_ROWSPAN'
export const SET_HRMS6AE_COLUMNS = 'SET_HRMS6AE_COLUMNS'
export const GET_HRMS6AE_COLUMNS = 'GET_HRMS6AE_COLUMNS'
export const SET_HRMS6AE_LABELS = 'SET_HRMS6AE_LABELS'
export const GET_HRMS6AE_LABELS = 'GET_HRMS6AE_LABELS'
export const RECEIVED_HRMS6AE_COLUMNS_LABELS = 'RECEIVED_HRMS6AE_COLUMNS_LABELS'
export const SET_HRMS6AE_INDEX = 'SET_HRMS6AE_INDEX'
export const GET_HRMS6AE_INDEX = 'GET_HRMS6AE_INDEX'
export const SET_HRMS6AE_INDEX_SELECTED = 'SET_HRMS6AE_INDEX_SELECTED'
export const GET_HRMS6AE_INDEX_SELECTED = 'GET_HRMS6AE_INDEX_SELECTED'
export const RECEIVED_HRMS6AE_INDEX = 'RECEIVED_HRMS6AE_INDEX'
export const SET_HRMS6AE_CURRENT_NUMSEQ = 'SET_HRMS6AE_CURRENT_NUMSEQ'
export const GET_HRMS6AE_CURRENT_NUMSEQ = 'GET_HRMS6AE_CURRENT_NUMSEQ'
export const RECEIVED_HRMS6AE_CURRENT_NUMSEQ = 'RECEIVED_HRMS6AE_CURRENT_NUMSEQ'
export const SET_HRMS6AE_DETAIL = 'SET_HRMS6AE_DETAIL'
export const GET_HRMS6AE_DETAIL = 'GET_HRMS6AE_DETAIL'
export const RECEIVED_HRMS6AE_DETAIL = 'RECEIVED_HRMS6AE_DETAIL'
export const SET_HRMS6AE_DETAIL_SEARCH = 'SET_HRMS6AE_DETAIL_SEARCH'
export const GET_HRMS6AE_DETAIL_SEARCH = 'GET_HRMS6AE_DETAIL_SEARCH'
export const RECEIVED_HRMS6AE_DETAIL_SEARCH = 'RECEIVED_HRMS6AE_DETAIL_SEARCH'
export const TOGGLE_HRMS6AE_PAGE = 'TOGGLE_HRMS6AE_PAGE'
export const POST_HRMS6AE_SAVE = 'POST_HRMS6AE_SAVE'
export const POST_HRMS6AE_CANCEL = 'POST_HRMS6AE_CANCEL'
export const GET_HRMS6AE_SAVE_BUTTON_DISP = 'GET_HRMS6AE_SAVE_BUTTON_DISP'
export const SET_HRMS6AE_SAVE_BUTTON_DISP = 'SET_HRMS6AE_SAVE_BUTTON_DISP'



// WEBPACK FOOTER //
// ./src/store/modules/hrms6ae/mutation-types.js